<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查隐患管理
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <!-- <ul class="tab-wrap" style="border:none" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <el-button
          type="primary"
          size="mini"
          v-hasPermi="['inspection:wenwuInspectionAppHidden:submitMerge']"
          class="btn"
          :disabled="!(multipleSelection.length > 0)"
          @click="put"
          >提报</el-button
        >
        <el-button type="primary" size="mini" v-hasPermi="['inspection:wenwuInspectionAppHidden:list']" class="btn" @click="showDia = true">
          查询
        </el-button>
        <el-button type="success" size="mini" v-hasPermi="['inspection:wenwuInspectionAppHidden:export']" class="btn" @click="output">
          导出数据
        </el-button>
        <router-link
          v-if="false"
          v-hasPermi="['safe:user:add']"
          class="btn ml20"
          :to="{ path: '/safe/safe-adduser', query: { inspection: tabList[nowIndex].id == 0 ? 1 : 2 } }"
          ><i class="icon-tr-newly-added"></i>新增</router-link
        >
      </div>
      <div class="common-page common-list">
        <el-table :row-key="getRowKeys" ref="table" :data="list" class="" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            :selectable="selectable"
            width="55"
            :reserve-selection="true"
          ></el-table-column>
          <el-table-column prop="serialNo" label="序号" align="center"> </el-table-column>
          <el-table-column prop="pointNum" align="center" label="检查点编号"></el-table-column>
          <el-table-column prop="companyName" align="center" label="所属单位"></el-table-column>
          <el-table-column prop="checkBig" align="center" label="巡查大项"></el-table-column>
          <el-table-column prop="checkSmall" align="center" label="巡查小项"></el-table-column>
          <el-table-column prop="patrolData" align="center" label="巡查数据"></el-table-column>
          <el-table-column prop="state" align="center" label="提报状态">
            <template slot-scope="scope">
              <el-tag :type="scope.row.state == 0 ? 'warning' : scope.row.state == 1 ? '' : 'success'">
                {{ scope.row.state == 0 ? "未提报" : scope.row.state == 1 ? "已提报" : "已完成" }}
              </el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="STATUS" align="center" label="标签类型">
            <template slot-scope="scope">
              {{ $map.NFCStatus[scope.row.xc_nfc] }}
            </template>
          </el-table-column> -->
          <el-table-column prop="STATUS" align="center" v-if="false" label="状态">
            <template slot-scope="scope">
              {{ $map.menuStatus[scope.row.status] }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <router-link
                v-hasPermi="['inspection:wenwuInspectionAppHidden:query']"
                :to="{
                  path: '/wenwu/safe-danger-detail',
                  query: { id: scope.row.id },
                }"
              >
                <el-button type="warning" size="mini">详情</el-button>
              </router-link>
              <router-link
                v-if="false"
                v-hasPermi="['safe:user:edit']"
                :to="{
                  path: '/safe/safe-adduser',
                  query: { id: scope.row.user_id, inspection: tabList[nowIndex].id == 0 ? 1 : 2 },
                }"
              >
                <el-button type="warning" size="mini">编辑</el-button>
              </router-link>
              <el-popconfirm
                v-if="false"
                title="确定此删除该单位吗？"
                class="cursor"
                v-hasPermi="['safe:user:remove']"
                @confirm="changeStatus(scope.row)"
                @onConfirm="changeStatus(scope.row)"
              >
                <a slot="reference" class="red" v-if="scope.row.status == 1">
                  <el-button type="danger" size="mini">删除</el-button>
                </a>
                <a slot="reference" class="blue" v-if="scope.row.status != 1">
                  开启
                </a>
              </el-popconfirm>
              <!--                            <el-popconfirm title="确定删除吗？" class="cursor" @onConfirm="changeStatus(scope.row,2)">-->
              <!--                                <a slot="reference" class="red">-->
              <!--                                    删除-->
              <!--                                </a>-->
              <!--                            </el-popconfirm>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="params.pageSize || 10"
        @current-change="pageChange"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <!-- v-if="tabList[nowIndex].id == 0" -->
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <!-- <fm-generate-form
        :data="searchForm1"
        :remote="remoteFuncs"
        :value="editData"
        v-if="tabList[nowIndex].id == 1"
        ref="searchForm"
      >
      </fm-generate-form> -->
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      multipleSelection: [], // tab 选择项
      list: [],
      tabList: this.$store.state.user.userInfo.isWenwu ? [{ name: "文物巡查", id: 1 }] : [{ name: "消防巡查", id: 0 }],

      nowIndex: 0,
      params: { pageNum: 1, pageSize: 10, user_name: "", nick_name: "", x_company_area: "", inspectionType: 1 },
      total: 0,
      showDia: false,
      searchForm: this.$getForm("dangerSearch"),
      searchForm1: this.$getForm("userSearchww"),

      editData: {},
      remoteFuncs: {
        _this: this,
        getArea(resolve) {
          var _this = this._this;
          _this
            .$post("/xuncha/xunchaareadetail", {
              c_company_num: _this.$store.state.user.company.cCompanyNum,
            })
            .then((res) => {
              console.log(res);
              resolve(res.data);
            });
        },
        getWWArea(resolve) {
          var _this = this._this;
          _this
            .$post("/xuncha/xunchaareadetailWenWu", {
              c_company_num: _this.$store.state.user.company.cCompanyNum,
            })
            .then((res) => {
              resolve(res.data);
            });
        },
      },
    };
  },
  created() {
    this.params.inspectionType = this.tabList[this.nowIndex].id == 0 ? 1 : 2;
    this.getList();
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    handleSelectionChange(val) {
      if (val.length > 30) {
        this.$refs.table.selection.pop();
        this.$message({
          type: "error",
          message: "最多选择30个隐患进行提报!",
        });
      }
      // console.log(this.$refs.table,val)
      this.multipleSelection = val;
      // .map((item) => {
      //   return item.serialNo;
      // });
    },
    selectable(row, index) {
      if (row.state != 0) return false;
      else return true;
    },
    output() {
      // this.$get(
      //   "/culturalRelics/wenwuBasicInformation/export",
      //   this.params
      // ).then((res) => {
      //   console.log(this.download)
      //    this.download(res.msg)
      // });
      this.downLoadExcel("/inspection/wenwuInspectionAppChild/export", this.params);
    },
    put() {
      let params = this.multipleSelection.map((item) => {
        return item.id;
      });
      let showInfo = this.multipleSelection.map((item) => {
        return item.serialNo;
      });
      this.$confirm(
        `确认提报编号${showInfo.toString()}等${
          this.multipleSelection.length
        }个隐患进行方案设计吗，点击确定将进入方案设计环节。`,
        "",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          // type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$get("/inspection/wenwuInspectionAppChild/submitMerge/" + params.toString()).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "隐患提报成功!",
              });
              this.multipleSelection = [];
              this.$refs.table.clearSelection(); // 清除表格的选择
              this.getList();
            }
            // this.total = res.total;
            // this.list = res.rows;
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消提报",
          });
        });
    },
    open() {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning",
        center: true,
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    cancle() {
      // this.showDia=false
      this.resetSearch();
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.params = {
        pageNum: 1,
        pageSize: 10,
        user_name: "",
        nick_name: "",
        x_company_area: "",
        inspectionType: this.tabList[this.nowIndex].id == 0 ? 1 : 2,
      };
      this.getList();
    },
    changeStatus(it, del) {
      let status = it.status == 1 ? 0 : 1;
      if (del) status = del;
      this.$post("/user/updateuserstatus", {
        user_id: it.user_id,
        status: status,
      }).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      });
    },
    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{
      // })//this.params
      this.$get("/inspection/wenwuInspectionAppChild/hiddenDangerList", this.params).then((res) => {
        console.log(res);
        this.total = res.total;
        this.list = res.rows;
      });
    },
    pageChange(val) {
      this.params.pageNum = val;
      this.params.inspectionType = this.tabList[this.nowIndex].id == 0 ? 1 : 2;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.pageNum = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
